<div class="final-step">
  <div class="text-center icon-block">
    <div class="notification-icon mt-3">
      <img src="/assets/images/fireworks.svg" alt="success"/>
    </div>
  </div>

  <div class="title">
    {{ 'create_partner_component.success_title' | translate }}
  </div>

  <!-- Email already proven via OTP: announce the account as ready when the brand
       auto-approves (support verification off), else keep the "support will review"
       copy. Email not yet verified: show the verify-via-link block. -->
  <div class="subtitle">
    @if (emailOtpVerified) {
      @if (isPendingSupportApproval) {
        <span [innerHtml]="'create_partner_component.verified_account_created' | translate: { supportEmail: supportEmail } | calioSafe: 'html'"></span>
      } @else {
        <span [innerHtml]="'create_partner_component.auto_approved_account_created' | translate | calioSafe: 'html'"></span>
      }
    } @else {
      <span [innerHtml]="'create_partner_component.unverified_account_created' | translate | calioSafe: 'html'"></span>
    }
    <br /><br />
  </div>

  @if (!emailOtpVerified && !(blockForTimeMinutes$() || blockForTimeSeconds$() || statusMessage$())) {
    <div class="subtitle mt-3">
      @if (!isResendEmailSend$()) {
        {{ 'create_partner_component.not_get_mail' | translate }}
        <button type="button" class="link" (click)="resendMail()">{{ 'create_partner_component.send_again' | translate }}</button>
      } @else {
        <span class="success-email-send">{{ 'create_partner_component.verify_email_send' | translate }}</span>
        <div>{{ 'create_partner_component.send_again_in' | translate : { 'time': remainingTime$() } }}</div>
      }
    </div>
  }

  <!-- Handel Error -->
  @if (statusMessage$()) {
    <div class="custom-form-error text-center">
      {{ 'error_messages.exceptions.' + statusMessage$() | translate }}
    </div>
  }

  <!-- Handel TooManyRequestsException-->
  @if (blockForTimeMinutes$() || blockForTimeSeconds$()) {
    <div class="custom-form-error text-center">
      @if (blockForTimeMinutes$()) {
        {{ 'error_messages.exceptions.' + ((blockForTimeMinutes$() === 1) ? 'blockforminute' : 'blockforminutes') | translate
        : { time: blockForTimeMinutes$() } }}
      }
      @if (blockForTimeSeconds$()) {
        {{ 'error_messages.exceptions.' + ((blockForTimeSeconds$() === 1) ? 'blockforsecond' : 'blockforseconds') | translate
        : {
        time: blockForTimeSeconds$() } }}
      }
    </div>
  }

  <div class="text-center mt-5">
    <a class="button" [href]="redirectDomain" target="_blank">
      {{ 'create_partner_component.go_to_dashboard' | translate }}
    </a>
  </div>

  @if (thankYouUrl) {
    <div class="text-center mt-3">
      <a class="button" [href]="thankYouUrl" target="_blank" rel="noopener">
        {{ 'create_partner_component.go_to_thank_you' | translate }}
      </a>
    </div>
  }
</div>